var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebApi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 468,
    height: 414,
    viewBox: "0 0 468 414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web-api",
    transform: "translate(5489 -2491)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1131",
    "data-name": "Rectangle 1131",
    width: 468,
    height: 414,
    transform: "translate(-5489 2491)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(-68 536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(-0.331 -0.108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_969",
    "data-name": "Rectangle 969",
    width: 95.017,
    height: 179.613,
    transform: "translate(-5363.26 2143.049)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_970",
    "data-name": "Rectangle 970",
    width: 95.017,
    height: 179.613,
    transform: "translate(-5391.457 2143.049)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M154.352,266.738H72.79V238.27h81.562Zm-80.565-1h79.559V239.276H73.788Z",
    transform: "translate(-5457.783 1913.279)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M104.15,238.88H135.1v2.168a3.5,3.5,0,0,1-3.5,3.5H107.687a3.5,3.5,0,0,1-3.5-3.5V238.88Z",
    transform: "translate(-5463.288 1913.172)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M154.352,310.608H72.79V282.14h81.562Zm-80.565-1h79.559V283.138H73.788Z",
    transform: "translate(-5457.783 1905.577)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M104.15,282.75H135.1v2.168a3.5,3.5,0,0,1-3.5,3.5H107.687a3.5,3.5,0,0,1-3.5-3.5V282.75Z",
    transform: "translate(-5463.288 1905.47)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M154.352,354.476H72.79V326h81.562Zm-80.565-1h79.559V327.006H73.788Z",
    transform: "translate(-5457.783 1897.877)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M104.15,326.61H135.1v2.168a3.5,3.5,0,0,1-3.5,3.5H107.687a3.5,3.5,0,0,1-3.5-3.5V326.61Z",
    transform: "translate(-5463.288 1897.77)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M154.352,398.346H72.79V369.87h81.562Zm-80.565-1.006h79.559V370.876H73.788Z",
    transform: "translate(-5457.783 1890.176)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M104.15,370.48H135.1v2.168a3.5,3.5,0,0,1-3.5,3.5H107.687a3.5,3.5,0,0,1-3.5-3.5V370.48Z",
    transform: "translate(-5463.288 1890.069)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_971",
    "data-name": "Rectangle 971",
    width: 103.212,
    height: 8.945,
    transform: "translate(-5395.669 2136.33)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_972",
    "data-name": "Rectangle 972",
    width: 31.032,
    height: 8.945,
    transform: "translate(-5292.465 2136.33)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 4.996,
    height: 9.176,
    transform: "translate(-5391.457 2322.662)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 4.996,
    height: 9.176,
    transform: "translate(-5360.606 2322.662)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 4.996,
    height: 9.176,
    transform: "translate(-5304.247 2322.662)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 4.996,
    height: 9.176,
    transform: "translate(-5276.076 2322.662)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M133.974,190.56l9.621,24.61-5.977-.033-4.8-15.12Z",
    transform: "translate(-5468.321 1921.655)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M93.686,162.99,90.38,210.132l34.132.717,3.842-47.859Z",
    transform: "translate(-5460.871 1926.495)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M97.944,167.541,95.19,206.784l25.376,1.187,3.545-40.662Z",
    transform: "translate(-5461.715 1925.736)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M104.841,174.32l-2.061,27.586h14l2.473-27.586Z",
    transform: "translate(-5463.048 1924.506)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 110.162,
    height: 108.241,
    transform: "translate(-5287.849 1955.108)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 102.445,
    height: 102.445,
    transform: "translate(-5284.015 1958.068)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 33.423,
    height: 33.423,
    transform: "translate(-5249.503 1992.579)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M355.311,12.08c-1.245,17.767,0,50.843-6.464,67.431s-15.1,33.67-31.329,41.09c-19.927,9.135-43.349,5.268-64.612,10.619-33.332,8.385-57.423,38.963-67.712,71.727s-9.1,67.942-7.865,102.289l170.091,23.6s.89-69.113,15.73-87.976,85.3-35.839,108.579-87.5C492.68,106.875,499,33.145,499,33.145Z",
    transform: "translate(-5475.996 1952.988)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M477.157,101.111c0,.239-15.524-1.649-34.627-4.279s-34.519-4.889-34.47-5.136,15.524,1.649,34.627,4.287S477.19,100.88,477.157,101.111Z",
    transform: "translate(-5516.642 1939.015)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M474.9,117.911c0,.231-15.533-1.649-34.627-4.287s-34.519-4.9-34.487-5.128,15.516,1.649,34.627,4.279S474.928,117.68,474.9,117.911Z",
    transform: "translate(-5516.243 1936.065)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M467.211,135.039c0,.231-15.524-1.69-34.627-4.287s-34.528-4.9-34.495-5.136,15.524,1.649,34.627,4.287S467.269,134.8,467.211,135.039Z",
    transform: "translate(-5514.891 1933.059)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M453.221,152.319c0,.231-15.524-1.69-34.627-4.287s-34.528-4.9-34.495-5.136,15.524,1.649,34.627,4.287S453.271,152.047,453.221,152.319Z",
    transform: "translate(-5512.435 1930.026)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M430.951,169.561c0,.231-15.524-1.649-34.627-4.287s-34.528-4.9-34.495-5.128,15.524,1.649,34.627,4.279S430.984,169.322,430.951,169.561Z",
    transform: "translate(-5508.525 1926.997)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M525.856,108.122c-.041.239-3.85-.19-8.508-.948s-8.4-1.566-8.368-1.8,3.85.19,8.508.948S525.9,107.891,525.856,108.122Z",
    transform: "translate(-5534.358 1936.62)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M481.283,83.991c0,.231-15.533-1.649-34.627-4.287s-34.52-4.9-34.487-5.128,15.516,1.649,34.627,4.279S481.283,83.752,481.283,83.991Z",
    transform: "translate(-5517.363 1942.02)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M529.976,91c0,.231-3.842-.19-8.5-.948s-8.409-1.566-8.376-1.8,3.85.19,8.508.948S530.018,90.771,529.976,91Z",
    transform: "translate(-5535.082 1939.625)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M485.931,66.861c0,.239-15.524-1.649-34.627-4.279s-34.519-4.9-34.495-5.136,15.524,1.649,34.627,4.287S485.964,66.63,485.931,66.861Z",
    transform: "translate(-5518.178 1945.027)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M534.636,73.872c0,.239-3.842-.19-8.508-.948s-8.4-1.566-8.368-1.8,3.85.19,8.508.956S534.678,73.641,534.636,73.872Z",
    transform: "translate(-5535.9 1942.633)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M488.121,49.741c0,.231-15.524-1.649-34.627-4.287S419,40.557,419,40.326s15.524,1.649,34.627,4.279S488.154,49.5,488.121,49.741Z",
    transform: "translate(-5518.562 1948.032)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M536.835,56.747c0,.231-3.85-.19-8.508-.948s-8.409-1.566-8.327-1.814,3.842.19,8.508.948S536.868,56.516,536.835,56.747Z",
    transform: "translate(-5536.293 1945.643)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M525.126,123.1c-.041.231-3.85-.2-8.508-.956s-8.409-1.558-8.368-1.8,3.842.2,8.508.956S525.159,122.861,525.126,123.1Z",
    transform: "translate(-5534.23 1933.992)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M520.046,143.816c0,.231-3.85-.214-8.517-.989s-8.451-1.583-8.36-1.756c0-.3,3.842.148,8.5.915S520.087,143.585,520.046,143.816Z",
    transform: "translate(-5533.338 1930.359)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M512.706,161.406c0,.239-3.85-.214-8.517-.981s-8.451-1.591-8.36-1.764,3.85.148,8.5.915S512.747,161.134,512.706,161.406Z",
    transform: "translate(-5532.05 1927.263)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M496.926,178.026c0,.231-3.858-.214-8.517-.989s-8.451-1.583-8.36-1.756,3.842.148,8.492.915S496.959,177.795,496.926,178.026Z",
    transform: "translate(-5529.279 1924.345)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M404.523,189.511c0,.239-23.291-2.861-51.94-6.917s-51.866-7.535-51.833-7.766,23.291,2.861,51.94,6.917S404.556,189.28,404.523,189.511Z",
    transform: "translate(-5497.803 1924.418)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M388.239,206.486a5.26,5.26,0,0,1-1.154-.091l-3.3-.429-12-1.748-39.573-6.1c-15.442-2.473-29.416-4.691-39.524-6.381l-11.954-2.069c-1.41-.256-2.473-.462-3.248-.618a6.322,6.322,0,0,1-1.113-.289,6.91,6.91,0,0,1,1.154.115l3.257.462,12,1.8,39.573,6.142,39.524,6.34,11.971,2.02,3.24.594A6.694,6.694,0,0,1,388.239,206.486Z",
    transform: "translate(-5493.522 1921.97)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M362.374,222.786c.148.148-1.525,0-4.279-.371s-6.818-.915-11.79-1.649c-9.951-1.443-23.686-3.529-38.84-5.895s-28.856-4.576-38.749-6.225l-11.74-1.987-3.182-.585a6.439,6.439,0,0,1-1.1-.256,5.036,5.036,0,0,1,1.129.091l3.207.42,11.781,1.723,38.823,5.969,38.8,6.15Z",
    transform: "translate(-5489.365 1918.976)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M470.558,201.725c0,.231-3.85-.214-8.517-.989s-8.442-1.583-8.352-1.756c0-.3,3.842.14,8.492.915S470.6,201.495,470.558,201.725Z",
    transform: "translate(-5524.652 1920.193)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M450.236,213.043c-.041.231-3.858-.214-8.525-.989s-8.442-1.583-8.352-1.764,3.842.148,8.492.915S450.269,212.8,450.236,213.043Z",
    transform: "translate(-5521.083 1918.199)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M422.868,232.1c0,.231-3.85-.214-8.517-.989s-8.442-1.583-8.352-1.756c0-.3,3.842.14,8.492.915S422.909,231.865,422.868,232.1Z",
    transform: "translate(-5516.279 1914.861)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M346.834,258.575c0,.231-28.79-4-64.208-9.448s-64.109-10.058-64.076-10.289,28.781,4,64.208,9.448S346.867,258.344,346.834,258.575Z",
    transform: "translate(-5483.372 1913.181)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M344.326,299.069c0,.239-9.456-1.1-21.04-2.968s-20.949-3.578-20.916-3.817,9.465,1.1,21.048,2.976S344.367,298.838,344.326,299.069Z",
    transform: "translate(-5498.087 1903.801)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M473.776,189.62c-4.765.1-7.643,5.54-7.89,10.3s1.055,9.63-.115,14.246c-1.484,5.87-6.686,10.281-8.038,16.176-1.591,6.958,2.515,13.9,3.042,21.015.264,3.463-.33,7.008.47,10.38a12.779,12.779,0,0,0,25.047-.973c.824-5.392-1.773-10.949-.618-16.283.824-3.949,3.71-7.42,3.759-11.435.066-4.807-3.842-8.764-4.765-13.48s1.253-9.465,1.377-14.263c.223-8.615-3.661-15.186-12.268-15.664",
    transform: "translate(-5525.298 1921.82)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M479.06,216.9a5.836,5.836,0,0,1,0,.758c0,.544-.082,1.27-.14,2.193-.148,1.937-.346,4.666-.594,8.03-.511,6.785-1.2,16.159-1.9,26.514s-1.278,19.737-1.69,26.531c-.206,3.364-.371,6.1-.495,8.038-.066.915-.115,1.649-.148,2.185a6.787,6.787,0,0,1-.082.759,3.822,3.822,0,0,1,0-.758c0-.544,0-1.27.066-2.193.082-1.946.206-4.683.355-8.047.33-6.8.824-16.184,1.558-26.547s1.443-19.729,2.028-26.506c.313-3.355.561-6.084.742-8.022.091-.915.165-1.649.223-2.185a4.054,4.054,0,0,1,.082-.75Z",
    transform: "translate(-5528.215 1917.03)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M472.833,322.906h0a15.211,15.211,0,0,0,15.2-15.2V292.5H457.63v15.2A15.2,15.2,0,0,0,472.833,322.906Z",
    transform: "translate(-5525.344 1903.758)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M457.63,301.51a2,2,0,0,1,.495.33l1.336,1.039,4.7,3.809h-.247l8.764-5.375h0l.148-.082.132.091,8.154,5.375h-.247l5.153-3.8,1.459-1.039a2.342,2.342,0,0,1,.544-.33,2.531,2.531,0,0,1-.462.437l-1.393,1.129-5.037,3.957-.124.091-.132-.082-8.195-5.309h.256l-8.813,5.3-.132.082-.115-.1-4.584-3.957-1.261-1.121A2.659,2.659,0,0,1,457.63,301.51Z",
    transform: "translate(-5525.343 1902.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M457.63,297.822a1.928,1.928,0,0,1,.495.338l1.336,1.031,4.7,3.809h-.247l8.764-5.367h0l.148-.082.132.091,8.154,5.375h-.247l5.153-3.8,1.459-1.039a2.343,2.343,0,0,1,.544-.33,4.361,4.361,0,0,1-.462.437l-1.393,1.138-5.037,3.949-.124.1-.132-.091-8.195-5.309h.272l-8.813,5.293-.132.082-.115-.1L459.3,299.4l-1.261-1.129C457.762,298,457.613,297.839,457.63,297.822Z",
    transform: "translate(-5525.343 1902.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M457.63,305.26a2,2,0,0,1,.495.33l1.336,1.039,4.7,3.809h-.247l8.764-5.375h0l.148-.082.132.091,8.154,5.375h-.247l5.153-3.8,1.459-1.039a2.341,2.341,0,0,1,.544-.33,2.531,2.531,0,0,1-.462.437l-1.393,1.13-5.037,3.957-.124.091-.132-.082-8.195-5.309h.256l-8.8,5.268-.132.082-.115-.1-4.584-3.957-1.261-1.121C457.762,305.425,457.613,305.277,457.63,305.26Z",
    transform: "translate(-5525.343 1901.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M499.676,422.51l9.7,27.833h-4.848L487.54,422.51Z",
    transform: "translate(-5530.595 1880.934)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M432.662,422.51l-9.712,27.833h4.856L444.79,422.51Z",
    transform: "translate(-5519.255 1880.934)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    width: 77.547,
    height: 77.547,
    transform: "translate(-5032.139 2304.145) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    width: 77.547,
    height: 77.547,
    transform: "translate(-5007.834 2304.145) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M509.718,403.229H442.41v-67.3h67.308Zm-66.3-1h65.3v-65.3h-65.3Z",
    transform: "translate(-5522.672 1896.134)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M508.9,361.181c-21.889-.635-44.017-.47-65.956,0a.264.264,0,1,0,0,.528c21.9.445,44.025.61,65.956,0a.239.239,0,0,0,0-.47Z",
    transform: "translate(-5522.719 1891.774)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M480.94,349.318a1.88,1.88,0,1,0,.551-1.337A1.888,1.888,0,0,0,480.94,349.318Z",
    transform: "translate(-5529.436 1894.115)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M513.92,386.058a1.88,1.88,0,1,0,.551-1.337A1.888,1.888,0,0,0,513.92,386.058Z",
    transform: "translate(-5535.226 1887.665)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M278.758,438.148,133.111,272.2a12.367,12.367,0,0,1,1.146-17.5L235.664,165.71a12.367,12.367,0,0,1,17.5,1.138L398.772,332.768a12.367,12.367,0,0,1-1.138,17.5L296.228,439.253A12.408,12.408,0,0,1,278.758,438.148Z",
    transform: "translate(-5467.83 1926.561)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M397.148,370.759a16.951,16.951,0,1,1,1.558-23.909A16.95,16.95,0,0,1,397.148,370.759Z",
    transform: "translate(-5509.786 1895.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M405.316,394a18.376,18.376,0,0,1-4.32.239,17.692,17.692,0,1,1,4.32-.239Zm-6.027-33.374a16.134,16.134,0,1,0,13.5,28.031h0a16.134,16.134,0,0,0-9.588-28.221,16.745,16.745,0,0,0-3.916.19Z",
    transform: "translate(-5512.504 1892.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M191.441,257.411l-10.248,8.995-.923-1.055,9.308-8.162-2.111-2.424.94-.824Z",
    transform: "translate(-5476.651 1910.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M192.206,277.776l-.932.824L185,271.411l.742-.66,7.906.6c2.16.148,3.042-.231,3.743-.824,1.187-1.039,1.187-2.473-.19-4.081a4.617,4.617,0,0,0-3.595-1.8V263.34a6.142,6.142,0,0,1,4.65,2.35c1.822,2.078,1.921,4.32.206,5.821-.973.824-2.127,1.327-4.675,1.13l-6.488-.478Z",
    transform: "translate(-5477.482 1908.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M205.691,289.916l-1.8-2.053-2.688,2.366-.932-1.055,2.7-2.358-5.07-5.771.758-.668,11.542-.528,1.022,1.171-11.212.569,3.908,4.444,2.366-2.078.907,1.022-2.374,2.078,1.8,2.053Z",
    transform: "translate(-5479.747 1905.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M222.409,308.965l-1.8-2.053-2.7,2.366-.923-1.055,2.7-2.366-5.079-5.771.767-.668,11.542-.528,1.031,1.171-11.212.569,3.908,4.444L223.011,303l.9,1.022-2.383,2.069,1.8,2.053Z",
    transform: "translate(-5482.68 1902.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M232.239,318.97c-1.74,1.525-4.172,1.509-6.365-1a7.016,7.016,0,0,1-1.9-4.823l1.278-.223a5.9,5.9,0,0,0,1.583,4.188c1.525,1.74,3.182,1.921,4.427.824s1.418-2.7-.866-5.3l-1.921-2.177,5.6-3.982,4.947,5.606-.932.824-4.122-4.683-3.57,2.515,1.154,1.319C234.243,315.153,234.053,317.379,232.239,318.97Z",
    transform: "translate(-5484.323 1901.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M243.2,331.4c-1.913,1.649-4.468,1.253-6.216-.742-2.383-2.721-1.8-5.854,1.435-8.7,3.487-3.05,6.975-2.745,9.407.041a6.191,6.191,0,0,1,1.583,2.91l-1.22.33a4.8,4.8,0,0,0-1.27-2.416c-1.937-2.21-4.6-2.383-7.42.058a9.727,9.727,0,0,0-.824.775,4.337,4.337,0,0,1,4.5,1.591C245.027,327.276,245.076,329.749,243.2,331.4Zm-.94-1.014c1.344-1.179,1.336-2.935-.049-4.518s-3.3-1.789-4.551-.668c-1.129.989-1.377,2.861.181,4.633,1.294,1.476,3.026,1.748,4.419.552Z",
    transform: "translate(-5486.352 1898.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M257.871,348.149c-1.715,1.5-4.122,1.41-6.29-1.064a7.041,7.041,0,0,1-1.921-4.84l1.278-.223a6,6,0,0,0,1.608,4.221c1.484,1.7,3.1,1.937,4.37.824s1.278-2.646-.387-4.543l-.643-.734.775-.684,6.051-.28-4.6-5.243.932-.824,5.771,6.6-.742.66-6.192.3C259.7,344.6,259.512,346.706,257.871,348.149Z",
    transform: "translate(-5488.833 1896.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M269.065,360.86c-1.921,1.649-4.477,1.261-6.216-.734-2.391-2.721-1.806-5.854,1.435-8.7,3.479-3.05,6.967-2.745,9.407.041a6.241,6.241,0,0,1,1.575,2.91l-1.22.33a4.839,4.839,0,0,0-1.261-2.416c-1.946-2.218-4.609-2.383-7.42.049-.239.214-.519.478-.824.783a4.361,4.361,0,0,1,4.51,1.583C270.887,356.746,270.961,359.219,269.065,360.86Zm-.948-1.014c1.352-1.179,1.344-2.927-.049-4.51s-3.3-1.789-4.551-.668c-1.121.989-1.369,2.861.181,4.633,1.3,1.476,3.059,1.74,4.419.544Z",
    transform: "translate(-5490.892 1893.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M286.253,365.519l-.75.651-13.265,4.048-1-1.138,13.01-3.957-4.625-5.268L277.7,361.5l-.89-1.031L279.666,358Z",
    transform: "translate(-5492.622 1892.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M301.8,383.284l-.742.651L287.8,387.983l-1-1.138,13-3.957-4.592-5.285-1.913,1.649-.915-1.039,2.853-2.473Z",
    transform: "translate(-5495.354 1889.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M305.066,402.32c-1.814,1.591-4.287,1.047-6.431-1.4s-2.341-4.947-.528-6.53a3.4,3.4,0,0,1,4.246-.239,3.083,3.083,0,0,1,.824-3.586c1.649-1.459,3.957-.956,5.862,1.212s2.127,4.526.462,5.985a3.092,3.092,0,0,1-3.693.346A3.43,3.43,0,0,1,305.066,402.32Zm-.932-1.1c1.253-1.1,1.1-2.886-.495-4.7s-3.3-2.185-4.584-1.08-1.121,2.877.47,4.691,3.331,2.185,4.609,1.08Zm.338-5.433c1.4,1.6,2.951,1.921,4.065.94s.973-2.638-.379-4.172-2.919-1.921-4.065-.915-1.022,2.547.379,4.139Z",
    transform: "translate(-5497.122 1886.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M317.93,412.33c-3.487,3.059-6.975,2.745-9.415,0a6.307,6.307,0,0,1-1.575-2.919l1.22-.322a4.832,4.832,0,0,0,1.27,2.416c1.937,2.21,4.6,2.383,7.42-.058.239-.206.519-.478.824-.775a4.37,4.37,0,0,1-4.51-1.591c-1.781-2.036-1.83-4.51.049-6.15s4.469-1.253,6.216.734C321.755,406.353,321.162,409.494,317.93,412.33Zm.759-3.232c1.129-.989,1.377-2.869-.181-4.642-1.294-1.476-3.059-1.74-4.419-.544s-1.344,2.935.049,4.518,3.273,1.8,4.551.668Z",
    transform: "translate(-5498.889 1884.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M335.051,421.059,324.8,430.046l-.923-1.055,9.308-8.17-2.127-2.416.94-.824Z",
    transform: "translate(-5501.863 1881.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M335.819,441.418l-.932.824-6.307-7.181.742-.66,7.906.6c2.16.148,3.042-.231,3.743-.824,1.187-1.039,1.187-2.515-.19-4.081a4.634,4.634,0,0,0-3.595-1.8V426.99a6.117,6.117,0,0,1,4.65,2.35c1.83,2.078,1.929,4.32.214,5.821-.981.824-2.127,1.327-4.683,1.129l-6.48-.478Z",
    transform: "translate(-5502.688 1880.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M347.831,450.647c-1.715,1.5-4.122,1.41-6.29-1.064a7.041,7.041,0,0,1-1.921-4.839l1.278-.223a6,6,0,0,0,1.608,4.221c1.484,1.7,3.1,1.937,4.37.824s1.3-2.63-.346-4.559l-.643-.734.775-.676,6.043-.28-4.592-5.243.932-.824,5.771,6.6-.742.66-6.192.3C349.662,447.094,349.464,449.2,347.831,450.647Z",
    transform: "translate(-5504.626 1878.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    width: 5.92,
    height: 109.206,
    transform: "matrix(0.751, -0.66, 0.66, 0.751, -5240.927, 2263.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_983",
    "data-name": "Rectangle 983",
    width: 5.92,
    height: 56.013,
    transform: "translate(-5214.738 2311.16) rotate(-41.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_984",
    "data-name": "Rectangle 984",
    width: 45.823,
    height: 34.231,
    rx: 4.96,
    transform: "translate(-5256.235 2131.258) rotate(48.73)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M206.4,231.457l1.649-1.443,15.566,17.734a4.947,4.947,0,1,0,7.42-6.521l-15.566-17.734,1.649-1.443,15.557,17.734a7.131,7.131,0,1,1-10.719,9.408Z",
    transform: "translate(-5481.239 1916.126)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_985",
    "data-name": "Rectangle 985",
    width: 2.193,
    height: 16.192,
    transform: "translate(-5250.749 2165.869) rotate(-41.22)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    "data-name": "Rectangle 986",
    width: 117.846,
    height: 10.116,
    transform: "translate(-5231.489 2116.748) rotate(48.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1024",
    "data-name": "Rectangle 1024",
    width: 269.412,
    height: 165.136,
    rx: 15.94,
    transform: "translate(-5325.938 2088.751)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(-6233.554 969.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M323.867,373.77H286.789v32.995L276.02,425.933h58.607l-10.76-19.168Z",
    transform: "translate(743.796 900.807)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    width: 299.315,
    height: 194.67,
    rx: 14.77,
    transform: "translate(897.554 1081.165)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_988",
    "data-name": "Rectangle 988",
    width: 89.715,
    height: 9.425,
    transform: "translate(1004.266 1326.74)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M74.131,172.59h-60.4A13.784,13.784,0,0,1,0,158.849V13.732A13.732,13.732,0,0,1,13.732,0L74.139.034H267.776a13.724,13.724,0,0,1,13.732,13.7V158.85a13.732,13.732,0,0,1-13.732,13.74Z",
    transform: "translate(906.444 1092.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(929.11 1129.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M171.388,93.161H16.962a8.78,8.78,0,0,1-5.653-14.913L71.444,18.114a62.3,62.3,0,0,1,87.917,0l30.067,31.631a25.5,25.5,0,0,1-18.04,43.417Z",
    transform: "translate(-8.791 0.039)",
    fill: "#00aeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M171.388,93.161H16.962a8.78,8.78,0,0,1-5.653-14.913L71.444,18.114a62.3,62.3,0,0,1,87.917,0l30.067,31.631a25.5,25.5,0,0,1-18.04,43.417Z",
    transform: "translate(35 0.039)",
    fill: "#150958",
    opacity: 0.22
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebApi);
export default __webpack_public_path__ + "static/media/web-api.5391c95c8e1bba407583dc4613112b65.svg";
export { ForwardRef as ReactComponent };